import {
    API_GetDocuments,
    API_GetAllowedFileExtensions
  } from '../../apiCalls/api.js';
//import { useToast } from "vue-toastification";
//import i18n from '../../locales/i18n'
  
//const toast = useToast();

const state = () => ({
    documents: [],
    allowedExtensions:[]
})

// getters
const getters = {
}

//actions
const actions = {
    
    async getDocuments({ commit }){
        const documentResponse = await API_GetDocuments();
        commit('setDocuments', documentResponse.data.Documents)
    },

    async getAllowedFileExtensions({ commit }){
        const fileExtensionsResponse = await API_GetAllowedFileExtensions();
        commit('setFileExtensions', fileExtensionsResponse.data)
    }
}

const mutations = {
   setDocuments(state, data){
        state.documents = data.sort((a, b) =>(a.Name.toLowerCase() > b.Name.toLowerCase()) ? 1:-1);
   },
   setFileExtensions(state, data){
        state.allowedExtensions = data
   },
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
  }